(function () {
	'use strict';

	angular.module('qbePortal').controller('QBYesNoController', QBYesNoController);
	QBYesNoController.$inject = ['$scope' /*, '$state' */ ];

	function QBYesNoController($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.id = vm.id || vm.name;
			vm.inputName = (vm.sectionName ? (vm.sectionName + '_') : '') + vm.id;
			vm.yesFieldId = vm.inputName + '_yes';
			vm.noFieldId = vm.inputName + '_no';

			vm.registerHierarchy = function (name, setHierarchyFn) {
				vm.setHierarchy({
					name: name,
					setHierarchyFn: setHierarchyFn
				});
			}

			vm.onValueChanged = function () {
				vm.update({
					name: vm.name,
					value: vm.fieldValue
				});

				vm.valueChange();
				if (vm.commonValue !== undefined) {
					$scope.$emit('common-value-update', {
						name: vm.commonValue,
						value: (vm.fieldValue)
					});
				}

				if (vm.requote !== undefined) {
					$scope.$root.$broadcast('requote', vm.requote);
				}
			}

			vm.isRequired = function (condition) {
				if (condition) {

					// Unselect radios when no longer mandatory
					if (condition === 'false') {
						$('#' + vm.yesFieldId).attr('checked', false);
						$('#' + vm.noFieldId).attr('checked', false);
					}

					return condition === 'true';

					// Defaults to `true` if `required` attribute is not set
				} else {
					return true;
				}
			}
		}
	}

	angular.module('qbePortal').component('qbYesNo', {
		templateUrl: '/ngviews/components/qbYesNo.html',
		controller: QBYesNoController,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			ariaLabel: '@',
			required: '@',
			update: '&',
			id: '@?',
			sectionName: '<',
			fieldValue: '<',
			commonValue: '@?',
			requote: '@?',
			valueChange: '&',
			tableData: '<', // data in the associated table.
		}
	});
})();
